import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';
import { GetPaycheckoutConfigurationResponse } from 'src/models/BusinessPayment/PaymentCheckout/Configuration';
import { PaycheckoutConfigurationParams } from 'src/pages/RequestMoney/types';

export function getPaycheckoutConfiguration() {
  return axios.request<GetPaycheckoutConfigurationResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/payment-checkout/configuration`,
  });
}

export function updatePaycheckoutConfiguration(
  data: PaycheckoutConfigurationParams,
) {
  return axios({
    method: 'put',
    url: `${BUSINESS_PAYMENT_PREFIX}/payment-checkout/configuration`,
    data,
  });
}
